import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as tableHelpers from 'app/helpers/tableSelectionHelpers';

interface DeleteData {
  users: any;
  title: string;
  buttonText: string;
  primaryColor?: boolean;
  isWarning?: boolean;
  statusColumn?: boolean;
}

@Component({
  standalone: false,
  selector: 'app-confirm-delete-dialog',
  templateUrl: './confirm-delete-dialog.component.html',
  styleUrls: ['./confirm-delete-dialog.component.scss']
})
export class ConfirmDeleteDialogComponent implements OnInit {
  private paginator: MatPaginator;
  private sort: MatSort;
  public buttonText = 'Delete';
  displayedColumns = ['name', 'email'];
  dataSource = new MatTableDataSource();
  usersCount: number;
  warnColor = true;
  isWarning: boolean;
  status: boolean;
  @ViewChild(MatPaginator, { static: false }) set matPaginator(
    mp: MatPaginator
  ) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatSort, { static: false }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  constructor(@Inject(MAT_DIALOG_DATA) public data: DeleteData) {}

  ngOnInit() {
    this.dataSource.data = this.data.users;
    if (this.data.buttonText) {
      this.buttonText = this.data.buttonText;
    }
    if (this.data.primaryColor) {
      this.warnColor = false;
    }
    this.isWarning = this.data.isWarning;
    this.setDataSourceAttributes();
    this.status = this.data.statusColumn;
  }

  setDataSourceAttributes() {
    this.dataSource.data.sort((a, b) =>
      a['name'].toLowerCase() > b['name'].toLowerCase() ? 1 : -1
    );
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = tableHelpers.sortingDataAccessor;
  }
}
